import { Button, ICON_COLOR, Tooltip } from '@zep-us/zus';
import { ChartLineIcon, PenPaperIcon, PlayFillIcon, QrcodeIcon, RectanglePortraitStackFillIcon, SchoolFillIcon, SquareStackIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { NewChip } from '@/shared/components/Chip/NewChip';
import { CTAButtonRightSlot } from './CTAButtonRightSlot';
import { WorksheetGradientIcon } from './WorksheetGradientIcon';
export interface OwnerCTAButtonsProps {
  onEnter: () => void;
  onShare: () => void;
  onGoToLms: () => void;
  onDuplicate: () => void;
  onEdit: () => void;
  onExportWorksheet: () => void;
  onFlashcard: () => void;
  onLinkToClassroom?: () => void;
}
export const OwnerCTAButtons = ({
  onEnter,
  onShare,
  onGoToLms,
  onDuplicate,
  onEdit,
  onExportWorksheet,
  onFlashcard,
  onLinkToClassroom
}: OwnerCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  const buttonsStyle = 'group w-full justify-start px-md gap-xs';
  return <div className="flex w-full flex-col gap-xs text-body-md-semibold" data-sentry-component="OwnerCTAButtons" data-sentry-source-file="OwnerCTAButtons.tsx">
      <Button size="md" variant="contained" intent="gradient" onClick={onEnter} leftSlot={<PlayFillIcon size="sm" fill={ICON_COLOR.inverse} />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
        {t('detail.cta.enter')}
      </Button>
      <Button size="md" variant="outlined" intent="neutral" onClick={onFlashcard} leftSlot={<RectanglePortraitStackFillIcon size="sm" className="text-blue-300" />} rightSlot={<CTAButtonRightSlot badge={<NewChip className="bg-blue-50 text-blue-500" />} />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
        {t('common:flashcard.label')}
      </Button>
      <Button size="md" variant="outlined" intent="neutral" onClick={onExportWorksheet} leftSlot={<WorksheetGradientIcon size="sm" />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
        {t('common:quizWorksheet.label')}
      </Button>

      {onLinkToClassroom && <Tooltip.Provider>
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Button size="md" variant="outlined" intent="neutral" onClick={onLinkToClassroom} leftSlot={<SchoolFillIcon size="sm" className="text-purple-300" />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle}>
                {t('common:classroom.linkToClassroom')}
              </Button>
            </Tooltip.Trigger>
            <Tooltip.Content side="bottom" sideOffset={6} className="z-modal max-w-[230px] rounded-2xs bg-[rgba(28,27,31,0.8)] p-2xs shadow-lg">
              <span className="text-body-sm-semibold text-white">
                {t('common:classroom.linkTooltip')}
              </span>
              <Tooltip.Arrow className="fill-[rgba(28,27,31,0.8)]" />
            </Tooltip.Content>
          </Tooltip.Root>
        </Tooltip.Provider>}

      <div className="flex w-full flex-col gap-xs pt-sm">
        <p className="text-caption-lg-semibold text-alternative">
          {t('common:detail.quizManagement')}
        </p>

        <Button size="md" variant="outlined" intent="neutral" onClick={onGoToLms} leftSlot={<ChartLineIcon size="sm" fill={ICON_COLOR.neutral} />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
          {t('detail.learningReport')}
        </Button>

        <Button size="md" variant="outlined" intent="neutral" onClick={onShare} leftSlot={<QrcodeIcon size="sm" fill={ICON_COLOR.neutral} />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
          {t('detail.cta.share')}
        </Button>

        <Button size="md" variant="outlined" intent="neutral" onClick={onDuplicate} leftSlot={<SquareStackIcon size="sm" fill={ICON_COLOR.neutral} />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
          {t('detail.copy')}
        </Button>

        <Button size="md" variant="outlined" intent="neutral" onClick={onEdit} leftSlot={<PenPaperIcon size="sm" fill={ICON_COLOR.neutral} />} rightSlot={<CTAButtonRightSlot />} className={buttonsStyle} data-sentry-element="Button" data-sentry-source-file="OwnerCTAButtons.tsx">
          {t('detail.edit')}
        </Button>
      </div>
    </div>;
};